import styled from "styled-components";

export const StyledContainer = styled("div")<{
  border?: boolean;
}>`
  position: relative;
  width: 100%;
  max-width: 1280px;
  margin-right: auto;
  margin-left: auto;
  padding: 0 72px;
  overflow: visible;
  border-top: ${(p) => (p.border ? "1px solid rgba(31, 23, 64, 0.08)" : "")};

  @media only screen and (max-width: 1024px) {
    max-width: calc(100% - 44px);
    padding: 0 22px;
  }

  @media only screen and (max-width: 768px) {
    max-width: calc(100% - 26px);
    padding: 0 18px;
  }

  @media only screen and (max-width: 414px) {
    max-width: 100%;
    padding: 0 18px;
  }
`;
